import { useApolloClient } from "@apollo/client";
import Tabs, {
  TabItem,
  TabItemBadge,
} from "@mostrans/web-components/components/base/Tabs";
import Grid from "@mui/material/Grid";
import { isEmpty, orderBy } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import {
  GetOpportunityByID,
  getCalendarInvitation,
  getCandidatesByOpportunityID,
} from "../../../GQL/queries";
import { titleAtoms } from "../../../shared/atoms/titleAtoms";
import { globalLoadingScreenAtom } from "../../../shared/globalStates";
import { toastError } from "../../../shared/helpers";
import { useGetStatusAdmin } from "../../../shared/hooks/useGetMasterData";
import CandidatesByStatus from "./CandidatesByStatus";
import FilterCandidate from "./FilterCandidate";
import Header from "./Header";

function Candidate() {
  const [selectedTab, setSelectedTab] = useState(1);
  const [listStatusAdmin] = useGetStatusAdmin();
  const [listCandidate, setListCandidate] = useState([]);
  const [listOpportunity, setListOpportunity] = useState([]);
  const [listCalendarInvitation, setListCalendarInvitation] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState([]);
  const [selectedAllCandidate, setSelectedAllCandidate] = useState([]);
  const [candidateNameValue, setCandidateNameValue] = useState("");
  const [candidateEmailValue, setCandidateEmailValue] = useState("");
  const [candidatePhoneNumberValue, setCandidatePhoneNumberValue] =
    useState("");
  const [candidateMajorValue, setCandidateMajorValue] = useState("");
  const [candidateSchoolValue, setCandidateSchoolValue] = useState("");
  const [candidateExperienceValue, setCandidateExperienceValue] = useState("");
  const [candidateExperienceCompanyValue, setCandidateExperienceCompanyValue] =
    useState("");
  const [candidateOrder, setCandidateOrder] = useState();
  const [candidateSkillValue, setCandidateSkillValue] = useState("");
  const [skillValue, setSkillValue] = useState();
  const [genderValue, setGenderValue] = useState({ male: "", female: "" });
  const [filterValueEducation, setFilterValueEducation] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [valueFilterExperienceMin, setValueFilterExperienceMin] =
    useState(null);
  const [valueFilterExperienceMax, setValueFilterExperienceMax] =
    useState(null);
  const [excludedFilterExperience, setExcludedFilterExperience] = useState([]);
  const { opportunityID } = useParams();
  const client = useApolloClient();
  const setTitle = useSetRecoilState(titleAtoms);
  const setIsLoading = useSetRecoilState(globalLoadingScreenAtom);

  const handleTabStatus = (item) => {
    setSelectedTab(item.id);
    setSelectedCandidate([]);
    setSelectedAllCandidate([]);
  };

  useEffect(() => {
    if (opportunityID) {
      async function fetchCandidate() {
        await fetchCandidateOpportunityByID();
        await fetchOpportunityByID();
        await fetchCalendarInvitation();
      }
      fetchCandidate();
    }
  }, [opportunityID]);

  useEffect(() => {
    setTitle("Candidate");
  }, []);

  const fetchCandidateOpportunityByID = async () => {
    try {
      setIsLoading(true);
      await getCandidatesByOpportunityID(client, parseInt(opportunityID)).then(
        (data) => setListCandidate(data)
      );
    } catch (error) {
      toastError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOpportunityByID = async () => {
    await GetOpportunityByID(client, parseInt(opportunityID)).then((data) =>
      setListOpportunity(data)
    );
  };

  const fetchCalendarInvitation = async () => {
    await getCalendarInvitation(client, parseInt(opportunityID)).then((data) =>
      setListCalendarInvitation(data)
    );
  };

  const candidateSkills = listCandidate.map((v) => v.skills);

  const filterCandidate = () => {
    const getArrSKill = [];
    skillValue?.map((skill) => {
      getArrSKill.push(skill.value.toLowerCase().trim());
    });

    const filteredCandidate = listCandidate?.filter((candidate) => {
      return !isEmpty(skillValue) ||
        !isEmpty(filterValueEducation) ||
        valueFilterExperienceMin !== null ||
        valueFilterExperienceMax !== null
        ? candidate.skills || candidate.Educations || candidate.TotalPengalaman
          ? candidate.status_hr_id === selectedTab &&
            (candidate?.full_name
              .toLowerCase()
              .match(candidateNameValue.toLowerCase()) ||
              candidate?.email
                .toLowerCase()
                .match(candidateEmailValue.toLowerCase()) ||
              candidate?.phone_number
                .toLowerCase()
                .match(candidatePhoneNumberValue.toLowerCase()) ||
              candidate?.Educations?.some((education) => {
                return education.school_name
                  .toLowerCase()
                  .includes(candidateSchoolValue.toLowerCase());
              }) ||
              candidate?.Educations?.some((education) => {
                return education.major
                  .toLowerCase()
                  .includes(candidateMajorValue.toLowerCase());
              }) ||
              candidate?.Experiences?.some((experience) => {
                return experience.job_position
                  .toLowerCase()
                  .includes(candidateExperienceValue.toLowerCase());
              }) ||
              candidate?.Experiences?.some((experience) => {
                return experience.company
                  .toLowerCase()
                  .includes(candidateExperienceCompanyValue.toLowerCase());
              }) ||
              candidate?.skills?.some((skill) => {
                return skill
                  .toLowerCase()
                  .includes(candidateSkillValue.toLowerCase())
                  .trim();
              })) &&
            candidate?.gender.match(genderValue.male) &&
            candidate?.gender.match(genderValue.female) &&
            (valueFilterExperienceMin !== null &&
            valueFilterExperienceMax !== null
              ? candidate.TotalPengalaman >= valueFilterExperienceMin &&
                candidate.TotalPengalaman <= valueFilterExperienceMax &&
                !excludedFilterExperience.includes(candidate.TotalPengalaman)
              : true) &&
            (!isEmpty(filterValueEducation)
              ? candidate?.Educations.some((education) => {
                  return filterValueEducation.includes(education.degree);
                })
              : true) &&
            (!isEmpty(getArrSKill)
              ? candidate?.skills?.some((skill) => {
                  return getArrSKill?.includes(skill.toLowerCase().trim());
                })
              : true)
          : null
        : candidate.status_hr_id === selectedTab &&
            (candidate?.full_name
              .toLowerCase()
              .match(candidateNameValue.toLowerCase()) ||
              candidate?.email
                .toLowerCase()
                .match(candidateEmailValue.toLowerCase()) ||
              candidate?.phone_number
                .toLowerCase()
                .match(candidatePhoneNumberValue.toLowerCase()) ||
              candidate?.Educations?.some((education) => {
                return education.school_name
                  .toLowerCase()
                  .includes(candidateSchoolValue.toLowerCase());
              }) ||
              candidate?.Educations?.some((education) => {
                return education.major
                  .toLowerCase()
                  .includes(candidateMajorValue.toLowerCase());
              }) ||
              candidate?.Experiences?.some((experience) => {
                return experience.job_position
                  .toLowerCase()
                  .includes(candidateExperienceValue.toLowerCase());
              }) ||
              candidate?.Experiences?.some((experience) => {
                return experience.company
                  .toLowerCase()
                  .includes(candidateExperienceCompanyValue.toLowerCase());
              }) ||
              candidate?.skills?.some((skill) => {
                return skill
                  .toLowerCase()
                  .includes(candidateSkillValue?.toLowerCase());
                // .trim();
              })) &&
            candidate?.gender.match(genderValue.male) &&
            candidate?.gender.match(genderValue.female);
    });
    return filteredCandidate;
  };

  const filtered = filterCandidate();
  const orderedCandidate = useMemo(() => {
    if (candidateOrder === "asc")
      return orderBy(filtered, (e) => e.Opportunity.created_date, "asc");
    else if (candidateOrder === "desc")
      return orderBy(filtered, (e) => e.Opportunity.created_date, "desc");
    else return filtered;
  }, [candidateOrder, filtered]);

  return (
    <React.Fragment>
      <Header
        dataOpportunity={listOpportunity}
        setCandidateNameValue={setCandidateNameValue}
        setCandidateEmailValue={setCandidateEmailValue}
        setCandidatePhoneNumberValue={setCandidatePhoneNumberValue}
        setCandidateSchoolValue={setCandidateSchoolValue}
        setCandidateMajorValue={setCandidateMajorValue}
        setCandidateExperienceValue={setCandidateExperienceValue}
        setCandidateExperienceCompanyValue={setCandidateExperienceCompanyValue}
        setCandidateSkillValue={setCandidateSkillValue}
        listCalendarInvitation={listCalendarInvitation}
      />
      <div className="form-row">
        <div className="col-md-12">
          <Tabs>
            {listStatusAdmin.map((item) => {
              return (
                <TabItem
                  style={{ fontSize: 14 }}
                  key={item.id}
                  current={selectedTab === item.id ? true : false}
                  onClick={() => handleTabStatus(item)}
                >
                  {item.status}{" "}
                  <TabItemBadge>
                    {
                      listCandidate.filter(
                        (status) => status.status_hr_id === item.id
                      ).length
                    }
                  </TabItemBadge>
                </TabItem>
              );
            })}
          </Tabs>
        </div>
      </div>
      <div style={{ marginTop: 20 }}></div>
      <Grid container spacing={3}>
        <FilterCandidate
          setCandidateNameValue={setCandidateNameValue}
          setCandidateOrder={setCandidateOrder}
          setSkillValue={setSkillValue}
          candidateSkills={candidateSkills}
          setGenderValue={setGenderValue}
          setFilterValueEducation={setFilterValueEducation}
          filterValueEducation={filterValueEducation}
          setValueFilterExperienceMin={setValueFilterExperienceMin}
          setValueFilterExperienceMax={setValueFilterExperienceMax}
          setSelectedExperience={setSelectedExperience}
          selectedExperience={selectedExperience}
          setExcludedFilterExperience={setExcludedFilterExperience}
        />
        <CandidatesByStatus
          opportunityID={opportunityID}
          // dataCandidates={filterCandidate()}
          dataCandidates={orderedCandidate}
          fetchCandidateOpportunityByID={fetchCandidateOpportunityByID}
          selectedCandidate={selectedCandidate}
          setSelectedCandidate={setSelectedCandidate}
          selectedAllCandidate={selectedAllCandidate}
          setSelectedAllCandidate={setSelectedAllCandidate}
          dataOpportunity={listOpportunity}
        />
      </Grid>
    </React.Fragment>
  );
}

export default Candidate;
